import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bae120c4")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_slide = _resolveComponent("slide")
  const _component_navigation = _resolveComponent("navigation")
  const _component_pagination = _resolveComponent("pagination")
  const _component_Vue3Carousel = _resolveComponent("Vue3Carousel")

  return (_openBlock(), _createBlock(_component_Vue3Carousel, {
    "items-to-show": _ctx.itemsToShow,
    "wrap-around": true
  }, {
    addons: _withId(() => [
      _createVNode(_component_navigation),
      _createVNode(_component_pagination)
    ]),
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.paths, (path) => {
        return (_openBlock(), _createBlock(_component_slide, { key: path }, {
          default: _withId(() => [
            _createVNode("img", {
              class: "d-block w-100",
              src: path,
              alt: ""
            }, null, 8, ["src"])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 1
  }, 8, ["items-to-show"]))
})